import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InitCompanyPage } from './init-company.page';

const routes: Routes = [
  {
    path: '',
    component: InitCompanyPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InitCompanyPageRoutingModule {}
